import React from 'react'
import { apiMiddleware } from 'redux-api-middleware'
import { routerMiddleware, replace } from 'connected-react-router'
import { Modal } from 'components'
import callAPI from 'utils/callAPI'
import keyMirror from 'pkeymirror'
import _ from 'lodash'
import { isPayBy } from 'utils'

// ------------------------------------
// Constants
// ------------------------------------
export const BANKCARD_CHANNEL_UPDATES = keyMirror({
  INIT_REQUEST: null,
  INIT_SUCCESS: null,
  SUBMIT_REQUEST: null,
  SUBMIT_SUCCESS: null,
  SHOW_PAGE: null,
}, 'BANKCARD_CHANNEL_UPDATES')

// ------------------------------------
// Actions
// ------------------------------------
export function init() {
  return (dispatch) => {
    if (!isPayBy()) {
      return dispatch({
        type: BANKCARD_CHANNEL_UPDATES.SHOW_PAGE,
        payload: {
          isFetching: false,
        },
      })
    }
    dispatch(
      callAPI({
        dispatch: dispatch,
        method: 'POST',
        endpoint: 'cgs/personal/card/queryCardList',
        requestAction: BANKCARD_CHANNEL_UPDATES.INIT_REQUEST,
        successAction: BANKCARD_CHANNEL_UPDATES.INIT_SUCCESS,
        success: function(result) {
          if (_.find(result.cardList, { cardCategory: 'TOKEN' })) {
            return dispatch({
              type: BANKCARD_CHANNEL_UPDATES.SHOW_PAGE,
              payload: {
                ...result,
                isFetching: false,
              },
            })
          }
          dispatch(replace('/bankcard/main'))
        },
        error: () => {
          dispatch({
            type: BANKCARD_CHANNEL_UPDATES.SHOW_PAGE,
            payload: {
              isFetching: false,
            },
          })
        },
      })
    )
  }
}

export function submit(data) {
  return (dispatch) => {
    dispatch(
      callAPI({
        dispatch: dispatch,
        method: 'POST',
        body: data,
        endpoint: 'cgs/personal/batchUnbindCard',
        requestAction: BANKCARD_CHANNEL_UPDATES.SUBMIT_REQUEST,
        successAction: BANKCARD_CHANNEL_UPDATES.SUBMIT_SUCCESS,
        success: function(result) {
          Modal.alert(
            <div className='font-sm'>Channel Updates</div>,
            <div className='font-sm'>
              To enhance the channel capability, we’d love you to reconfirm your
              bank card details.
            </div>,
            [
              {
                text: <span>Do it later</span>,
                onPress: () => dispatch(init()),
              },
              {
                text: <span className='green'>Confirm</span>,
                onPress: () => dispatch(replace('/bankcard/add-bank-card')),
              },
            ]
          )
        },
      })
    )
  }
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [BANKCARD_CHANNEL_UPDATES.INIT_REQUEST]: (state, action) => Object.assign({}, state, action.payload),
  [BANKCARD_CHANNEL_UPDATES.INIT_SUCCESS]: (state, action) => state,
  [BANKCARD_CHANNEL_UPDATES.SHOW_PAGE]: (state, action) => Object.assign({}, state, action.payload),
  [BANKCARD_CHANNEL_UPDATES.SUBMIT_REQUEST]: (state, action) => state,
  [BANKCARD_CHANNEL_UPDATES.SUBMIT_SUCCESS]: (state, action) => state,
}

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {}
function reducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}

export default function(history) {
  return {
    id: 'bankcardChannelUpdates',
    reducerMap: {
      bankcardChannelUpdatesState: reducer
    },
    // middlewares when this module needed
    middlewares: [apiMiddleware, routerMiddleware(history)]
    // Actions to fire when this module is added/removed
    // initialActions: [],
    // finalActions: []
  }
}
